<template>
  <!-- Banner Section -->
  <section class="banner-section banner-seven">
    <div class="container">
      <div class="home-banner">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <div class="section-search aos" data-aos="fade-up">
              <p>Discover the best restaurant.</p>
              <h1>Discover Places that People Love</h1>
              <div class="search-box search-box-seven">
                <form action="listing-grid-sidebar" class="form-block d-flex">
                  <div class="search-input line">
                    <div class="form-group mb-0">
                      <vue-select
                        class="form-control select category-select"
                        :options="CategorySeven"
                        placeholder="Choose Category"
                      />
                    </div>
                  </div>
                  <div class="search-input line">
                    <div class="form-group select-location mb-0">
                      <vue-select
                        class="form-control select category-select"
                        :options="LocationSeven"
                        placeholder="Location"
                      />
                      <i class="feather-map-pin"></i>
                    </div>
                  </div>
                  <div class="search-btn">
                    <button class="btn btn-primary" type="submit">
                      Search Now
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="banner-imgs aos" data-aos="fade-up">
              <div class="main-banner-1">
                <img
                  src="@/assets/img/banner/banner-img-1.png"
                  class="img-fluid"
                  alt="bannerimage"
                />
              </div>
              <div class="main-banner-2">
                <img
                  src="@/assets/img/banner/banner-img-2.png"
                  class="img-fluid"
                  alt="bannerimage"
                />
              </div>
              <div class="main-banner-3">
                <img
                  src="@/assets/img/banner/banner-img-3.png"
                  class="img-fluid"
                  alt="bannerimage"
                />
              </div>
              <div class="main-banner-4">
                <img
                  src="@/assets/img/banner/banner-img-4.png"
                  class="img-fluid"
                  alt="bannerimage"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="banner-bg-img">
          <div class="bg-one">
            <img
              src="@/assets/img/bg/banner-left-bg.png"
              class="img-fluid"
              alt="image"
            />
          </div>
          <div class="bg-two">
            <img
              src="@/assets/img/bg/banner-right-bg.png"
              class="img-fluid"
              alt="image"
            />
          </div>
          <div class="bg-three">
            <img
              src="@/assets/img/bg/banner-bottom-bg.png"
              class="img-fluid"
              alt="image"
            />
          </div>
        </div>
        <div class="foods-title aos" data-aos="fade-up">
          <a href="javascript:void(0);">Breakfast</a>
          <a href="javascript:void(0);">Lunch</a>
          <a href="javascript:void(0);">Snacks</a>
          <a href="javascript:void(0);">Dinner</a>
        </div>
      </div>
    </div>
  </section>
  <!-- /Banner Section -->
  <!-- Our-Category Section -->
  <section class="our-category-section our-category-section-seven">
    <div class="container">
      <div class="restaurants-sec">
        <div class="row">
          <div class="col-md-8">
            <div
              class="section-heading section-heading-seven d-flex align-items-center aos"
              data-aos="fade-up"
            >
              <div class="heading-img">
                <img
                  src="@/assets/img/heading-logo.png"
                  class="img-fluid m-0"
                  alt="img"
                />
              </div>
              <div>
                <h2>Our Category</h2>
                <p>Explore restaurants and cafes by your favorite cuisine</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-md-end aos" data-aos="fade-up">
            <div class="interset-btn">
              <router-link
                to="service-details"
                class="btn btn-primary more-btn more-btn-two"
                >View All
                <i class="feather-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-4 col-sm-6 aos" data-aos="fade-up">
            <div class="our-category-box">
              <a href="javascript:void(0);">
                <div class="our-category-img">
                  <img
                    src="@/assets/img/latest/category-img-1.png"
                    class="img-fluid"
                    alt="img"
                  />
                </div>
              </a>
              <div class="our-category-info">
                <h5><a href="javascript:void(0);">Pizza</a></h5>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 aos" data-aos="fade-up">
            <div class="our-category-box">
              <a href="javascript:void(0);">
                <div class="our-category-img">
                  <img
                    src="@/assets/img/latest/category-img-2.png"
                    class="img-fluid"
                    alt="img"
                  />
                </div>
              </a>
              <div class="our-category-info">
                <h5><a href="javascript:void(0);">Broast</a></h5>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 aos" data-aos="fade-up">
            <div class="our-category-box">
              <a href="javascript:void(0);">
                <div class="our-category-img">
                  <img
                    src="@/assets/img/latest/category-img-3.png"
                    class="img-fluid"
                    alt="img"
                  />
                </div>
              </a>
              <div class="our-category-info">
                <h5><a href="javascript:void(0);">Chicken</a></h5>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 aos" data-aos="fade-up">
            <div class="our-category-box">
              <a href="javascript:void(0);">
                <div class="our-category-img">
                  <img
                    src="@/assets/img/latest/category-img-4.png"
                    class="img-fluid"
                    alt="img"
                  />
                </div>
              </a>
              <div class="our-category-info">
                <h5><a href="javascript:void(0);">Burgers</a></h5>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 aos" data-aos="fade-up">
            <div class="our-category-box">
              <a href="javascript:void(0);">
                <div class="our-category-img">
                  <img
                    src="@/assets/img/latest/category-img-5.png"
                    class="img-fluid"
                    alt="img"
                  />
                </div>
              </a>
              <div class="our-category-info">
                <h5><a href="javascript:void(0);">Sandwiches</a></h5>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 aos" data-aos="fade-up">
            <div class="our-category-box">
              <a href="javascript:void(0);">
                <div class="our-category-img">
                  <img
                    src="@/assets/img/latest/category-img-6.png"
                    class="img-fluid"
                    alt="img"
                  />
                </div>
              </a>
              <div class="our-category-info">
                <h5><a href="javascript:void(0);">Shakes</a></h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Our-Category Section -->
</template>
<script>
export default {
  data() {
    return {
      CategorySeven: [
        "Choose Category",
        "Computer",
        "Automobile",
        "Car Wash",
        "Cleaning",
        "Electrical",
        "Construction",
      ],
      LocationSeven: ["USA", "UK", "UAE"],
    };
  },
};
</script>
